import React from 'react'
import { Tooltip } from '@material-ui/core'
import { getLinkIcon, MASTER_CATEGORY } from '../CommonUpdateCells'

import { NoImagePlaceholder } from '../../../assets'

export const MCCategoryImageComponent = (props) => {
  const { data } = props
  const activeShop = data && data.shop && data.shop.active
  const deletedShop = data && data.shop && data.shop.deleted
  const orphaned = !data.parentCategoryId
  let isParent = !!data.children

  const shouldHide =
    ((!activeShop || deletedShop) && !data.children) ||
    (orphaned && !isParent) ||
    (data.productType && data.productType == 'BUNDLE')
  let linkIcon = getLinkIcon(MASTER_CATEGORY, isParent, data, props.colDef.field)

  const thumbURL =
    (data && data.photo && data.photo.thumbURL) ||
    (data && data.photo && data.photo.publicURL) ||
    ''
  const handleIconOption = (event) => {
    if (props.onSyncChildEvent) {
      props.onSyncChildEvent(props, {
        icon: linkIcon.icon,
        title: linkIcon.title,
      })
    }
  }
  return (
    <div className="center-item-column">
      <div
        className="align-item-column-value"
        style={{ overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}
      >
        <img
          style={{ width: '4em' }}
          src={thumbURL}
          onError={(e) => {
            e.target.src = NoImagePlaceholder
          }}
        />
      </div>

      <div style={{ float: 'right' }}>
        <Tooltip title={linkIcon.title}>
          <img
            className="icon-validation"
            alt=""
            src={linkIcon.icon}
            hidden={shouldHide}
            onClick={(event) => handleIconOption(event)}
          />
        </Tooltip>
      </div>
    </div>
  )
}

export default MCCategoryImageComponent



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Components/MCCategoryImageComponent.js